// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../../common/JQueryView';

export default class IndexView extends JQueryView {
  constructor() {
    super('.funds');
  }

  // 「ファンド追加」押下時：それ自体を非表示にする
  @on({ event: 'click', selector: '.add-fund-button' })
  onClickAddFundButton(event: any) {
    $(event.target).hide();
  }

  // 「さらに表示」押下で非表示のLPをすべて見せる
  @on({ event: 'click', selector: '.more-investors' })
  onClickShowInvestors(event: any) {
    $(event.target)
      .parents('.inv-parent')
      .find($('.more-visible-investors-wrapper'))
      .removeClass('d-none');
    $(event.target)
      .parents('.inv-parent')
      .find('.close-investors')
      .removeClass('d-none');
    $(event.target).addClass('d-none');
  }

  // 「閉じる」押下で6番目以降のLPを非表示にする
  @on({ event: 'click', selector: '.close-investors' })
  onClickHideInvestors(event: any) {
    $(event.target)
      .parents('.inv-parent')
      .find($('.more-visible-investors-wrapper'))
      .addClass('d-none');
    $(event.target)
      .parents('.inv-parent')
      .find('.more-investors')
      .removeClass('d-none');
    $(event.target).addClass('d-none');
  }

  @on({ event: 'click', selector: '.cancel-button, #cancel_btn' })
  onClickCancelButton(event: any) {
    event.preventDefault();

    // 編集ボタン切り替え
    $('.new-edit-button:not(.active-edit-button)').each((index, element) => {
      $(element).removeClass('edit-button-disable');
      $(element).prop('disabled', false);
    });
    $('.add-fund-button').show();

    if ($('#cancel_modal').is(':visible')) {
      $('#cancel_modal').modal('hide');
    }
    $('.show-fund').removeClass('d-none');
    $('.fund-form').remove();
  }
}
